import { InvalidConfigurationError } from './invalid-configuration-error';
import { IotizeACLGroup } from './iotize-acl-group';

/**
 *
 */
export type ACLRightType = 'read' | 'write';

export class IotizeACL {
  public data: any;

  constructor(
    data: any,
    public aclGroup?: IotizeACLGroup,
  ) {
    this.data = data;
  }

  static create(profileName: string, aclGroup?: IotizeACLGroup): IotizeACL {
    return new IotizeACL(
      {
        $: {
          ProfileName: profileName,
          Rights: '',
        },
      },
      aclGroup,
    );
  }

  public toJson() {
    return this.data;
  }

  public listRights(): ACLRightType[] {
    let rights = this._getProperty('Rights', '');
    if (rights.length === 0) {
      return [];
    }
    return rights.split(',').map((entry: string) => {
      return entry.trim();
    });
  }

  public username(): string {
    return this._getProperty('ProfileName');
  }

  public hasRight(name: ACLRightType): boolean {
    if (this.username() === 'admin') {
      return true;
    }
    let rights = this.listRights();
    return rights.indexOf(name) !== -1;
  }

  protected _getProperty(name: string, defaultValue?: string) {
    if (!(name in this.data.$)) {
      if (defaultValue === undefined) {
        throw new InvalidConfigurationError(
          'Missing key ' + name + ' in IoTize ACL',
        );
      }
      return defaultValue;
    }
    return this.data.$[name];
  }
}
